export default __webpack_public_path__ + "static/media/bump_phone.65d08635.png";